"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/******/
(function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && _typeof(value) === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 0);
  /******/
})(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(1);
  /***/
},
/* 1 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony import */


  var _partials_featureDetection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
  /* harmony import */


  var _partials_iconAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
  /* harmony import */


  var _partials_albumsFlickity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
  /* harmony import */


  var _partials_keyboardNavigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
  /* harmony import */


  var _partials_logoBlinking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6);
  /* harmony import */


  var _partials_hintManagement__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7);
  /* harmony import */


  var _partials_lazyLoading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8);
  /*
   * Importing functions and execute them..
   */


  Object(_partials_featureDetection__WEBPACK_IMPORTED_MODULE_0__["default"])();
  Object(_partials_iconAction__WEBPACK_IMPORTED_MODULE_1__["default"])();
  Object(_partials_albumsFlickity__WEBPACK_IMPORTED_MODULE_2__["default"])();
  Object(_partials_keyboardNavigation__WEBPACK_IMPORTED_MODULE_3__["default"])();
  Object(_partials_logoBlinking__WEBPACK_IMPORTED_MODULE_4__["default"])();
  Object(_partials_hintManagement__WEBPACK_IMPORTED_MODULE_5__["default"])();
  Object(_partials_lazyLoading__WEBPACK_IMPORTED_MODULE_6__["default"])(); // import likeManagement from './partials/likeManagement';
  // likeManagement();

  /***/
},
/* 2 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return featureDetection;
  }); // Simple JS feature detection


  function featureDetection() {
    var className = '';
    var html = '';
    html = document.documentElement;
    className = html.className.replace('no-js', 'js');
    html.className = className;
  }
  /***/

},
/* 3 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return iconAction;
  });

  function iconAction() {
    $(document).ready(function () {
      $('.help-hover').hover(function () {
        // show help information below
        // console.log("ACTIVE ? " + $(this).parent().hasClass('active'));
        if ($(this).parent().hasClass('active')) {
          $(this).siblings('.help-text-active').addClass('show');
        } else {
          $(this).siblings('.help-text').addClass('show');
        }
      }, function () {
        // not hover
        $(this).siblings('.help-text').removeClass('show');
        $(this).siblings('.help-text-active').removeClass('show');
      }); // ICON ZOOM

      $('.icon-zoom').on('click', function () {
        $('.icon-zoom').toggleClass('active');
        $('.photo').find('figure').toggleClass('canvas');
        $('.photo').find('figure').toggleClass('zoom');
        $('.photo').find('figure').parent().toggleClass('frame-zoom');
      }); // ICON FULLSCREEN

      $('.icon-fullscreen.not-fullscreen').on('click', function () {
        $(this).css('display', 'none');
        $('.icon-fullscreen.is-fullscreen').css('display', 'inline');
        openFullscreen();
      });
      $('.icon-fullscreen.is-fullscreen').on('click', function () {
        $(this).css('display', 'none');
        $('.icon-fullscreen.not-fullscreen').css('display', 'inline-block');
        closeFullscreen();
      });
      var elem = document.documentElement;
      /* View in fullscreen */

      function openFullscreen() {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
      }
      /* View in fullscreen */


      function closeFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      }
    });
  }
  /***/

},
/* 4 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return albumsFlickity;
  });
  /* ********************************* */

  /* Flickity carousels initialization */

  /* https://flickity.metafizzy.co/    */

  /* ********************************* */


  function albumsFlickity() {
    $(document).ready(function () {
      // clicks on flip button adds a flip class that flips the photo
      $('.icon-flip').click(function () {
        $(this).closest('.flip-card').toggleClass('flip');
      }); // Double click enlarge the picture

      $('.flip-card').dblclick(function () {
        $(this).toggleClass('flip');
      }); // see the flip only when it's the selected photo

      $('.photo.is-selected').click(function () {
        $(this).toggleClass('flip');
      }); // creates a node list of all carousels on the same page

      var carousels = document.querySelectorAll('.album');
      carousels.forEach(function (carousel) {
        var flkty = new Flickity(carousel, {
          'contain': false,
          'wrapAround': true,
          'setGallerySize': true,
          'adaptiveHeight': false,
          'prevNextButtons': true,
          'pageDots': true,
          'selectedAttraction': 0.015,
          // attracts the position of the slider to the selected cell. Higher attraction makes the slider move faster.
          'friction': 0.15,
          // slows the movement of slider. Higher friction makes the slider feel stickier and less bouncy
          'hash': false,
          'lazyLoad': 1,
          'imagesLoaded': false,
          'fullscreen': false,
          'dragThreshold': 30,
          // The number of pixels a mouse or touch has to move before dragging begins
          'freeScroll': false,
          'freeScrollFriction': 0.1,
          // Slows movement of slider when freeScroll: true
          'bgLazyLoad': true,
          on: {
            staticClick: function staticClick(event, pointer, cellElement, cellIndex) {
              // alert ("clicked " + flkty.selectedElement.id);
              // You can click on a slide to go to it (only on desktop)
              if (matchMedia('screen and (min-width: 768px)').matches) {
                if (typeof cellIndex == 'number') {
                  var index = $(this).index();
                  flkty.selectCell(cellIndex);
                }
              } // Clicking on the first slide (only hero slide), you get to the next one
              // var hasHero = cellElement.classList.contains('photo-hero');
              // if (cellIndex == '0' && hasHero) {
              //   flkty.selectCell(1);
              // }

            },
            change: function change(event, pointer) {
              // alert ("changed " + flkty.selectedElement.id);

              /* add an 'album-selected' class to the last touched carousel */
              var selectedElement = flkty.selectedElement; // clean all album navigation classes

              $('.album-container').removeClass('album-selected');
              $('.album-container').removeClass('album-previous');
              $('.album-container').removeClass('album-next');
              $(selectedElement).closest('.album-container').addClass('album-selected');
              $('.album-selected').prev('.album-container').addClass('album-previous');
              $('.album-selected').next('.album-container').addClass('album-next'); // sets the width of the dots according to the number of slides (to make 100% in total)

              var $slidesNr = $('.album-selected ol>li').length;
              var $widthLi = 100 / $slidesNr + "%";
              $('.album-selected ol>li').css('width', $widthLi);
              $('.album-selected .photo-number').text(" of " + $slidesNr);
            }
          }
        }); // wrapAround only on desktop. no wrapAround on phone since it makes strange effects bouncing...

        if (matchMedia('screen and (max-width: 768px)').matches) {
          flkty.options.wrapAround = false;
        }
      });
    });
  }
  /***/

},
/* 5 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return keyboadNavigation;
  });
  /* ****************************** */

  /* TOP/BOTTOM keyboard navigation */

  /* ****************************** */


  function keyboadNavigation() {
    $(document).ready(function () {
      // Selection is done on the first album on page load
      $('.album').first().flickity().focus();
      $('.album-container').first().addClass('album-selected');
      $('.album-container').first().next().addClass('album-next'); // sets the width of the dots according to the number of slides (to make 100% in total)

      var $slidesNr = $('.album-selected ol>li').length;
      var $widthLi = 100 / $slidesNr + "%";
      $('.album-selected ol>li').css('width', $widthLi);
      window.addEventListener('keydown', function (event) {
        if (event.defaultPrevented) {
          return; // Do nothing if the event was already processed
        }

        var previousAlbum = $('.album-previous');
        var selectedAlbum = $('.album-selected');
        var nextAlbum = $('.album-next'); // The first album is the nextAlbum if no album is selected

        if (nextAlbum.length == 0) {
          nextAlbum = $('.album-container').first();
        } // The last album is the previousAlbum if no album is selected


        if (previousAlbum.length == 0) {
          previousAlbum = $('.album-container').last();
        }

        switch (event.key) {
          case 'Down': // IE/Edge specific value

          case 'ArrowDown':
            $('html, body').animate({
              scrollTop: nextAlbum.offset().top - 60
            }, 200, function () {}); // select the current flickity album for left/right navigation

            nextAlbum.find('.album').flickity().focus(); // clean navigation

            $('.album-container').removeClass('album-previous');
            $('.album-container').removeClass('album-next');
            $('.album-container').removeClass('album-selected'); // nextAlbum is now the selected album

            nextAlbum.addClass('album-selected'); // set the previous and next albums

            nextAlbum.prev('.album-container').addClass('album-previous');
            nextAlbum.next('.album-container').addClass('album-next');
            break;
          // press on UP key

          case 'Up': // IE/Edge specific value

          case 'ArrowUp':
            $('html, body').animate({
              scrollTop: previousAlbum.offset().top - 60
            }, 200, function () {}); // select the current flickity album for left/right navigation

            previousAlbum.find('.album').flickity().focus(); // clean navigation

            $('.album-container').removeClass('album-previous');
            $('.album-container').removeClass('album-next');
            $('.album-container').removeClass('album-selected'); // previoiusAlbum is now the selected album

            previousAlbum.addClass('album-selected'); // set the previous and next albums

            previousAlbum.prev('.album-container').addClass('album-previous');
            previousAlbum.next('.album-container').addClass('album-next');
            break;

          default:
            return;
          // Quit when this doesn't handle the key event.
        } // Cancel the default action to avoid it being handled twice


        event.preventDefault();
      }, true);
    });
  }
  /***/

},
/* 6 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return logoBlinking;
  });

  function logoBlinking() {
    $(document).ready(function () {
      var eyes = document.querySelector('#eyes');

      function setProperty(duration) {
        eyes.style.setProperty('--blinking-delay', duration + 's');
      }

      function changeAnimationTime() {
        var animationDuration = Math.random() * 10;
        setProperty(animationDuration);
      }

      setInterval(changeAnimationTime, 1000);
    });
  }
  /***/

},
/* 7 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return hintManagement;
  });

  function hintManagement() {
    $(document).ready(function () {
      // initialization on page load
      var hintId = $('.hint').attr("id");
      var hintStatus = localStorage.getItem(hintId);

      if (hintStatus === 'show' || !hintStatus) {
        $('.hint').addClass('show');
      } // click on the .hint


      $('.hint').click(function (event) {
        event.preventDefault();
        var hintId = $(this).attr("id");
        var hintStatus = localStorage.getItem(hintId);
        toggleHint(hintId, hintStatus);
      }); // function that inverts the show/hide

      function toggleHint(hintId, hintStatus) {
        if (hintStatus === 'hide') {
          localStorage.setItem(hintId, 'show');
        } else {
          localStorage.setItem(hintId, 'hide');
        }

        $('.hint').toggleClass('show');
      }
    });
  }
  /***/

},
/* 8 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__);
  /* harmony export (binding) */


  __webpack_require__.d(__webpack_exports__, "default", function () {
    return lazyLoading;
  });

  function lazyLoading() {
    $(document).ready(function () {
      if ('loading' in HTMLImageElement.prototype) {
        var images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(function (img) {
          img.src = img.dataset.src;
        });
      } else {
        // Dynamically import the LazySizes library
        var script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
        document.body.appendChild(script);
      }
    });
  }
  /***/

}
/******/
]);